import React from "react";
import _ from "lodash";
import Select from "react-select";

let BROWSERS = ["chrome", "edge", "safari"];

// can be multiselect
class BrowserSelector extends React.PureComponent {
  constructor(props) {
    super(props);
    // props:
    // selectedItems
    // handleChanged

    const { selectedItems } = props;
    const keys = BROWSERS;
    const allCategories = _.map(keys, (c) => {
      return {
        id: c,
        name: c,
      };
    });
    const options = _.map(allCategories, (c) => {
      return { value: c.id, label: c.name };
    });

    const selectedValue = _.filter(options, (option) => {
      return _.indexOf(selectedItems, option.value) !== -1;
    });

    this.state = {
      options,
      selectedValue,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(options) {
    this.setState({
      selectedValue: options,
    });

    this.props.handleChanged(_.map(options, "value"));
  }

  render() {
    const { isReadonly } = this.props;
    const { options, selectedValue } = this.state;

    return (
      <>
        <Select
          // className="w-24 z-50"
          defaultValue={selectedValue}
          value={selectedValue}
          onChange={this.handleChange}
          options={options}
          isSearchable={true}
          isMulti={true}
          isDisabled={isReadonly}
          // styles={{
          //   control: () => ({
          //     paddingLeft: 3,
          //   }),
          // }}
        />
      </>
    );
  }
}

export default BrowserSelector;
